/* eslint-disable no-unused-vars */
export default function AtcMainController(
    $scope,
    $state,
    settingsCabinClasses,
    atcFlightsFactory,
    l10nService,
) {
    'ngInject';

    const vm = this;
    let allAirportsLabel;
    let anyCabinLabel;
    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        allAirportsLabel = l10nService.localize('All Airports');
        anyCabinLabel = l10nService.localize('Any');
    }

    $scope.locationPlaceholder = l10nService.localize('City or Airport...');
    $scope.module = atcFlightsFactory.getModule();
    $scope.$state = $state;
    $scope.params = atcFlightsFactory.params;
    $scope.options = atcFlightsFactory.options;
    $scope.options.cabinClasses = prepareCabinClassesOptions(settingsCabinClasses);
    $scope.options.type = [
        {text: l10nService.localize('Leaving by'), value: 'false'}, {text: l10nService.localize('Arriving by'), value: 'true'},
    ];

    function prepareCabinClassesOptions(cabinClasses) {
        return _.map(cabinClasses, function(cabinClass) {
            return {text: cabinClass.ClassName, value: cabinClass.AmadeusCode};
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcMainController.js